/**
 * @generated SignedSource<<f1d372eb105fa3b4769d498f930fdd74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookButton_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BookModal_session">;
  readonly " $fragmentType": "BookButton_session";
};
export type BookButton_session$key = {
  readonly " $data"?: BookButton_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookButton_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookButton_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookModal_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "aa8700d6ff12a062738afd66f2a2367f";

export default node;
